import {
  type ComponentPropsWithRef,
  type ComponentPropsWithoutRef,
  type ElementType,
  type PropsWithChildren,
} from 'react';
import { TrackingPropsInterface } from '@marriott/mi-ui-library';

export enum MButtonType {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Tertiary = 'Tertiary',
}

export enum MButtonSize {
  S = 'S',
  M = 'M',
  L = 'L',
}

export enum MButtonIconPlacement {
  None = 'None',
  Leading = 'Leading',
  Trailing = 'Trailing',
}

export enum MButtonIconClass {
  Search = 'icon-search',
  ArrowRight = 'icon-arrow-right',
  ExternalArrow = 'icon-external-arrow',
  ForwardArrow = 'icon-forward-arrow',
  BackArrow = 'icon-back-arrow',
}

// New interface for aIcon prop
export interface MButtonAIcon {
  size?: string; // Use string to allow passing AIconSize or a custom size if needed
  icon: string;
}

type PolymorphicComponentProps<C extends ElementType, P = Record<string, unknown>> = PropsWithChildren<P & { as?: C }> &
  Omit<ComponentPropsWithoutRef<C>, keyof (P & { as?: C })>;

export type MButtonRef<C extends ElementType> = ComponentPropsWithRef<C>['ref'];

export type MButtonProps<C extends ElementType, P = Record<string, unknown>> = PolymorphicComponentProps<C, P> & {
  buttonText?: string;
  variant?: MButtonType;
  size?: MButtonSize;
  iconPlacement?: MButtonIconPlacement;
  iconClass?: string;
  // New optional aIcon prop
  aIcon?: MButtonAIcon;
  isExternal?: boolean;
  disabled?: boolean;
  type?: 'submit' | 'reset' | 'button';
  href?: string;
  target?: string;
  className?: string;
  trackingProperties?: TrackingPropsInterface;
  custom_click_track_value?: string;
  preTrackVal?: string;
  ref?: MButtonRef<C>;
};
